import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import axios from "axios";
import Api from "../Api/Api.json";
import { formatDate } from "../utility/DataTransformUtils";
import { BleClient, numberToUUID } from "@capacitor-community/bluetooth-le";
import MainContainer from "../components/Container/MainContainer";

// Conditionally import JStyle only on native platforms
let JStyle = null;
if (Capacitor.isNativePlatform()) {
  const JStyleModule = require("../JStylePlugin");
  JStyle = JStyleModule.default;
}

const WellnessPage = () => {
  const [isConnected, setConnected] = useState(false);
  const [batteryLevel, setBatteryLevel] = useState("NC");
  const [deviceTime, setStateDeviceTime] = useState("NC");
  const [devices, setDevices] = useState([]);
  const [isScanning, setIsScanning] = useState(false);
  const [status, setStatus] = useState("");
  const [pairState, setPairState] = useState("Pair");
  const [syncStatus, setSyncStatus] = useState("Sync not started.");
  const [deviceName, setDeviceName] = useState("শক্তিব্যান্ড");
  const navigate = useNavigate();

  let userid = JSON.parse(localStorage.getItem("user_info")).di_id;

  useEffect(() => {
    // Only initialize JStyle functionality on native platforms
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Web platform - device features not available");
      return;
    }

    JStyle.addListener("connectionResult", handleConnectionEvent); //auto connect event
    JStyle.addListener("disconnectionResult", handleDisconnectionEvent); //auto disconnect event

    var jstyle_address = localStorage.getItem("jstyle_address");
    if (jstyle_address === null) {
      setPairState("Pair");
    } else {
      setPairState("Unpair");

      JStyle.isConnected().then((result) => {
        if (result.connected === true) {
          setConnected(true);
          syncData();
        } else {
          JStyle.connect({ deviceId: jstyle_address });
        }
      });
    }

    JStyle.checkPermission().then((result) => {
      console.log(result.permission);
      if (result.permission === "granted") {
      } else {
        setStatus("App Requires Bluetooth Permission");
        JStyle.requestPermission();
      }
    });

    return () => {
      if (JStyle) {
        JStyle.removeListener("deviceFound");
        JStyle.removeListener("connectionResult");
        JStyle.removeListener("disconnectionResult");
        JStyle.removeListener("hrvDataResult");
        JStyle.stopScan();
        JStyle.disconnect();
      }
    };
  }, []);

  const pairDevice = async () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Device pairing not available on web platform");
      return;
    }

    if (pairState === "Pair") {
      console.log("pairing");
      try {
        await BleClient.initialize({ androidNeverForLocation: true });

        await BleClient.requestLEScan({}, (result) => {
          console.log("received new scan result", result);
        });

        setTimeout(async () => {
          await BleClient.stopLEScan();
          console.log("stopped scanning");
        }, 5000);
      } catch (error) {
        console.log(error);
      }
      console.log("After BleClient scan");

      JStyle.isScanning().then((result) => {
        setStatus(JSON.stringify(result.scanning));
        if (!result.scanning === true) {
          setStatus("Calling start scan");
          JStyle.addListener("deviceFound", handleDiscoverDevicesEvent);
          JStyle.startScan();
        }
      });
    } else if (pairState === "Unpair") {
      console.log("unpairing");
      JStyle.disconnect();
      localStorage.removeItem("jstyle_address");
      setPairState("Pair");
    }
  };

  const forgetDevice = () => {
    localStorage.removeItem("jstyle_address");
  };

  const connectDevice = (address) => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Device connection not available on web platform");
      return;
    }
    JStyle.connect({ deviceId: address });
    setDevices([]);
  };

  const setDeviceTime = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Device time setting not available on web platform");
      return;
    }
    const now = new Date();
    const formattedTime = formatDate(now);
    JStyle.setDeviceTime({ date: formattedTime }); //"yyyy.MM.dd HH:mm:ss"
  };

  const getDeviceTime = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Device time not available on web platform");
      return;
    }
    JStyle.getDeviceTime().then((result) => {
      setStateDeviceTime(result.devicetime);
    });
  };

  const getBatteryLevel = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Battery level not available on web platform");
      return;
    }
    JStyle.getBatteryLevel().then((result) => {
      setBatteryLevel(result.batterylevel);
    });
  };

  const syncData = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setSyncStatus("Data sync not available on web platform");
      return;
    }
    
    if (isConnected === false) return;
    //Fetch HRV,sleep,HR since last datetime
    //save last datetime
    setSyncStatus("Sync started");
    console.log('Reading local storage');
    var last_sleep_ts=localStorage.getItem("last_sleep_datetime");
    var last_hrv_ts=localStorage.getItem("last_hrv_datetime");
    if(last_hrv_ts===undefined || last_hrv_ts===null){last_hrv_ts="";}
    if(last_sleep_ts===undefined || last_sleep_ts===null){last_sleep_ts="";}
    last_hrv_ts="";
    last_sleep_ts="";
    console.log(last_hrv_ts);
    JStyle.getHRVData({'date':last_hrv_ts}).then(result=>{
      //Save HRV data with last saving
      console.log('HRV data read returned');
      localStorage.setItem("last_hrv_datetime",result.lasthrvtime);
      localStorage.setItem("last_hrv_data",result.hrvlist);
      //const hrvList=JSON.parse(result.hrvlist);
      //setStatus(JSON.stringify(result.hrvlist));
      //upload to server     
      console.log(last_sleep_ts);   
      //last_sleep_ts="2024-08-22 22:46:01";
      return JStyle.getSleepData({'date': last_sleep_ts});
    }).then(sleepResult => {
      //Save sleep data with last saving
      console.log('sleep data read returned');
      localStorage.setItem("last_sleep_datetime",sleepResult.lastsleeptime);
      localStorage.setItem("last_sleep_data",sleepResult.sleeplist);
      setSyncStatus("Read from device.");
      //const sleepList=JSON.parse(sleepResult.sleeplist);
      //setStatus(JSON.stringify(sleepResult.sleeplist));
      //save data locally
      
      const hrvDataRead=localStorage.getItem('last_hrv_data');
      //localStorage.setItem("last_sleep_data",null);
      //format [datatype-timestamp-array]
      //upload to server        
      const headers = { headers: { "Content-Type": "application/json" } }
      const url = Api.FITNESS_API;
      const requestData = {
        task: 'setSemionWellnessData',
        id:userid,
        sleep_list:sleepResult.sleeplist,
        hrv_list: hrvDataRead===null? []:hrvDataRead,
      };
      console.log(JSON.stringify(requestData));
      return axios.post(url,requestData,headers);
    }).then(uploadResult=>{
      if(uploadResult.data==='updated'){
        setSyncStatus("Uploaded Successfully.");
      }
      else {
        setSyncStatus("Uploaded.");
      }
      syncActivityData();
    }).catch(error => {
      setStatus(JSON.stringify(error));
    });
  };

  const syncActivityData = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Activity sync not available on web platform");
      return;
    }
    
    JStyle.getTotalActivityData({'date':''}).then(result=>{
      console.log(result.totalactivitylist);
      const headers = { headers: { "Content-Type": "application/json" } }
      const url = Api.FITNESS_API;
      const requestData = {
        task: 'setSemionTotalActivity',
        id:userid,
        total_activity_list:result.totalactivitylist,
      };
      console.log(JSON.stringify(requestData));
      return axios.post(url,requestData,headers);
    }).then(uploadResult=>{
      if(uploadResult.data==='updated'){
        setSyncStatus("Uploaded Activity Successfully.");
      }
      else {
        setSyncStatus("Uploaded Activity.");
      }
    }).catch(error => {
      setStatus(JSON.stringify(error));
    });
  };

  const setAutoMonitor = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Auto monitoring not available on web platform");
      return;
    }
    if (isConnected === false) {
      setStatus("Please connect to device first");
      return;
    }
    setStatus("Setting auto monitoring...");
    JStyle.setAutomaticMonitoring({"intervalTime":"30","datatype":"HRV","startTime":"00:00","endTime":"23:59","days":"1-1-1-1-1-1-1"}).then((result) => {
      console.log(result.setautomaticmonitoring);
      if (result.setautomaticmonitoring === true || result.setautomaticmonitoring === "true") {
        setStatus("Auto monitoring enabled successfully");
      } else {
        setStatus("Auto monitoring setting completed");
      }
    }).catch(error => {
      setStatus("Failed to set auto monitoring: " + JSON.stringify(error));
    });
  };

  const clearDeviceData = () => {};

  const checkBTPermission = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Bluetooth permission check not available on web platform");
      return;
    }
    JStyle.checkPermission().then((result) => {
      console.log(result.permission);
    });
  };

  const requestBTPermission = () => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      setStatus("Bluetooth permission request not available on web platform");
      return;
    }
    JStyle.requestPermission().then((result) => {
      console.log(result.permission);
    });
  };

  const handleDiscoverDevicesEvent = (device) => {
    setDeviceName("শক্তিব্যান্ড" + device.name.slice(6));
    setDevices([...devices, device]);
  };

  const handleConnectionEvent = (deviceInfo) => {
    if (!Capacitor.isNativePlatform() || !JStyle) {
      return;
    }
    setStatus("connected");
    localStorage.setItem("jstyle_address", deviceInfo.address);
    setConnected(true);
    setDeviceTime();
    getBatteryLevel();
    setPairState("Unpair");
  };

  const handleDisconnectionEvent = (deviceInfo) => {
    setStatus("disconnected");
    setConnected(false);
  };

  const handleHRVData = (hrvResult) => {
    console.log("from listener");
    console.log(JSON.stringify(hrvResult.hrvlist));
    if (Array.isArray(hrvResult.hrvlist)) {
      console.log("array");
    }
    console.log(hrvResult.lasthrvtime);
  };

  return (
    <div className="bg-white text-gray-800 min-h-screen p-4">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-blue-600">Wellness Dashboard</h1>
      </div>

      {/* Platform Warning for Web */}
      {!Capacitor.isNativePlatform() && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <div className="flex items-center">
            <svg className="w-5 h-5 text-yellow-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <span className="text-yellow-800 font-medium">Web Platform</span>
          </div>
          <p className="text-yellow-700 text-sm mt-1">
            Device features are not available on web platform. Use the mobile app for full functionality.
          </p>
        </div>
      )}

      {/* Device Status Card */}
      <div className="bg-gray-50 rounded-lg p-4 mb-6 shadow border border-gray-200">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Device Status</h2>
          <div
            className={`px-3 py-1 rounded-full text-sm font-medium ${
              isConnected
                ? "bg-green-100 text-green-600"
                : "bg-red-100 text-red-600"
            }`}
          >
            {isConnected ? "Connected" : "Disconnected"}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="bg-white p-3 rounded-lg border border-gray-200">
            <p className="text-gray-500 text-sm">Device Name</p>
            <p className="font-medium text-gray-800">{deviceName}</p>
          </div>
          <div className="bg-white p-3 rounded-lg border border-gray-200">
            <p className="text-gray-500 text-sm">Battery Level</p>
            <p className="font-medium text-gray-800 flex items-center">
              {batteryLevel !== "NC" ? (
                <>
                  {batteryLevel}%
                  <svg
                    className="w-4 h-4 ml-2 text-green-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2 6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
                    <path d="M18 9h2v2h-2V9z" />
                  </svg>
                </>
              ) : (
                "Not Available"
              )}
            </p>
          </div>
        </div>

        <div className="bg-white p-3 rounded-lg border border-gray-200 mb-4">
          <p className="text-gray-500 text-sm">Sync Status</p>
          <p className="font-medium text-gray-800">{syncStatus}</p>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            onClick={pairDevice}
            className={`px-4 py-2 rounded-lg transition-colors duration-200 flex-1 text-white ${
              pairState === "Pair"
                ? "bg-blue-500 hover:bg-blue-600"
                : "bg-red-500 hover:bg-red-600"
            }`}
          >
            {pairState}
          </button>
          <button
            onClick={forgetDevice}
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors duration-200 flex-1"
          >
            Forget Device
          </button>
          <button
            onClick={syncData}
            className="px-4 py-2 bg-purple-500 hover:bg-purple-600 text-white rounded-lg transition-colors duration-200 flex-1"
          >
            Sync Data
          </button>
          <button
            onClick={setAutoMonitor}
            className={`px-4 py-2 rounded-lg transition-colors duration-200 flex-1 text-white ${
              isConnected
                ? "bg-green-500 hover:bg-green-600"
                : "bg-gray-400 cursor-not-allowed opacity-50"
            }`}
            disabled={!isConnected}
          >
            Set Auto Monitor
          </button>
        </div>
      </div>

      {/* Device List */}
      {!isConnected && devices.length > 0 && (
        <div className="bg-gray-50 rounded-lg p-4 mb-6 shadow border border-gray-200">
          <h2 className="text-xl font-semibold mb-4 text-gray-800">
            Available Devices
          </h2>
          <div className="space-y-2">
            {devices.map((device) => (
              <div
                key={device.name}
                className="bg-white p-3 rounded-lg border border-gray-200 flex justify-between items-center"
              >
                <span className="text-gray-800">
                  {"শক্তিব্যান্ড" + device.name.slice(6)}
                </span>
                <button
                  onClick={() => connectDevice(device.mac)}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-lg transition-colors duration-200 text-sm"
                >
                  Connect
                </button>
              </div>
            ))}
          </div>
        </div>
      )}


    </div>
  );
};

export default WellnessPage;
